import React, { isValidElement, useMemo } from 'react';

import { useParams } from 'react-router-dom';

import { CloseCircleOutlined } from '@ant-design/icons';
import { Typography } from 'antd';

import classnames from 'classnames';

import {
  ButtonEditModuleProperties,
  CollapseView,
} from 'pages/product-full-view/shared/components';

import { DisplayProductOverlayInfo } from './DisplayProductInfoOverlay';

import {
  productDetailActionTypes,
  useProductDetail,
  useProductDetailDispatch,
} from '../ProductDetailContext';

import { useGetProductItemModules } from '../queries';
import {
  useCheckAllowEditProducts,
  useGetProductFullView,
  useGetProductOverlay,
} from 'hooks';

import {
  getDataProductModule,
  getProductSchemaHasValidData,
  groupProductModuleProperties,
} from '../utils';

import './OverlayProductDetail.less';

export const ProductBaseModulesOverlay = (props) => {
  const {
    productSchema,
    productEnums,
    dataProductModules: productOverlayModules,
    onClickEditBtn,
    customProperties,
  } = props;

  const { id: productId } = useParams();

  const { productFull } = useGetProductFullView({
    productId,
  });

  const dispatch = useProductDetailDispatch();

  const { originalProductId } = useGetProductOverlay();

  const { dataProductModules: originalProductOverlay } =
    useGetProductItemModules(originalProductId);

  const {
    baseModule: { activeModules, isShowOnlyValue },
    publicationError: { moduleNameError },
  } = useProductDetail();

  const { checkAllowEditProductFull } = useCheckAllowEditProducts();

  const filteredProductSchema = useMemo(() => {
    if (!isShowOnlyValue) {
      return productSchema;
    } else {
      return getProductSchemaHasValidData(productOverlayModules, productSchema);
    }
  }, [isShowOnlyValue, productSchema, productOverlayModules]);

  const isAllowEditProduct = checkAllowEditProductFull(productFull);

  return (
    <div className='product-detail-view__list-info product-detail__base-modules scroller'>
      {filteredProductSchema.map((module) => {
        const hasModuleName = activeModules.includes(module.moduleName);
        const isActiveBtnEdit = hasModuleName && isAllowEditProduct;

        const isErrorPublicationModuleName =
          module.moduleName.toLowerCase() === moduleNameError.toLowerCase();

        return (
          <CollapseView
            activeKey={activeModules}
            key={module.moduleName}
            className='product-detail-view__collapse--overlay'
            expandIconPosition='left'
            collapsible='header'
            keyPanel={module.moduleName}
            headerPanel={
              <Typography.Title
                level={5}
                className={classnames({
                  'product-detail-view__list-info-title': true,
                  'product-detail-view__list-info-title--publication-error':
                    isErrorPublicationModuleName,
                })}
              >
                {module.moduleDisplayName}
                {isErrorPublicationModuleName && (
                  <CloseCircleOutlined style={{ margin: '0 4px' }} />
                )}
              </Typography.Title>
            }
            extraPanel={() => {
              return (
                <>
                  {isActiveBtnEdit && (
                    <ButtonEditModuleProperties
                      moduleName={module.moduleName}
                      moduleDisplayName={module.moduleDisplayName}
                      onClick={onClickEditBtn}
                    />
                  )}
                </>
              );
            }}
            onChange={(value) => {
              dispatch({
                type: productDetailActionTypes.ACTIVE_MODULES,
                payload: {
                  value,
                  moduleView: 'base',
                },
              });
            }}
          >
            <DisplayProductOverlayInfo
              moduleProduct={groupProductModuleProperties(module)}
              dataProductOverlayModule={getDataProductModule(
                productOverlayModules,
                module.moduleName
              )}
              productEnums={productEnums}
              dataOriginalProductModule={getDataProductModule(
                originalProductOverlay,
                module.moduleName
              )}
            />
          </CollapseView>
        );
      })}
      {isValidElement(customProperties) && customProperties}
    </div>
  );
};
